import { Property } from 'csstype'
import { HTMLAttributes } from 'react'
import styled, { css } from 'styled-components'

import { BORDER_RADIUS } from '../../../styles'

const cellStyles = css<{ align?: Property.TextAlign }>`
  padding: 8px;
  text-align: ${({ align }) => align ?? 'left'};
  border: 1px solid ${({ theme }) => theme.colors.background.greyDark};
  border-top: none;
  border-right: none;
  font-size: 16px;
  &:last-child {
    border-right: 1px solid ${({ theme }) => theme.colors.background.greyDark};
  }
`

export const TableStyled = styled('table').withConfig({
  shouldForwardProp: (prop) => !['stickyHeader'].includes(prop)
})<{ stickyHeader?: boolean }>`
  border: 1px solid transparent;
  border-radius: ${BORDER_RADIUS};
  border-spacing: 0;
  border-collapse: separate;
  width: 100%;
  ${({ stickyHeader }) =>
    stickyHeader &&
    css`
      thead th {
        position: sticky;
        top: 0;
      }
    `}

  thead th {
    &:nth-child(1) {
      border-left: 1px solid ${({ theme }) => theme.colors.common.dark.brightBlue};
      border-top-left-radius: ${BORDER_RADIUS};
    }
    &:nth-last-child(1) {
      border-right: 1px solid ${({ theme }) => theme.colors.common.dark.brightBlue};
      border-top-right-radius: ${BORDER_RADIUS};
    }
    padding: 8px;
    font-size: 16px;
    background-color: ${({ theme }) => theme.colors.common.dark.brightBlue};
    color: ${({ theme }) => theme.colors.font.white};
  }

  tbody tr {
    th {
      ${cellStyles}
    }

    &:nth-child(1) {
      td,
      th {
        border-top: 1px solid ${({ theme }) => theme.colors.background.greyDark};
      }
    }
    &:nth-child(odd) {
      td,
      th {
        background-color: ${({ theme }) => theme.colors.background.grey};
      }
    }

    &:nth-child(even) {
      td,
      th {
        background-color: ${({ theme }) => theme.colors.background.white};
      }
    }

    &:nth-last-child(1) {
      td,
      th {
        &:nth-child(1) {
          border-bottom-left-radius: ${BORDER_RADIUS};
        }
        &:nth-last-child(1) {
          border-bottom-right-radius: ${BORDER_RADIUS};
        }
      }
    }

    &:not(:nth-last-child(1)) {
      td,
      th {
        border-bottom: 1px solid ${({ theme }) => theme.colors.background.greyDark};
      }
    }

    ${({ theme, ...props }) => {
      if (props.onClick) {
        return css`
          &:hover {
            td,
            th {
              transition-duration: 0.3s;
              cursor: pointer;
              background-color: ${theme.colors.background.greyMid};
            }
          }
        `
      }
    }}
  }
`

export const THead = styled.thead``

export const TBody = styled.tbody``

export const Th = styled('th').withConfig({
  shouldForwardProp: (prop) => !['align'].includes(prop)
})<{ align?: Property.TextAlign }>`
  text-align: ${({ align }) => align ?? 'left'};
`

export const Tr = styled.tr<HTMLAttributes<HTMLTableRowElement>>`
  td {
    ${({ onClick }) =>
      onClick &&
      css`
        cursor: pointer;
      `}
  }
`

export const Td = styled('td').withConfig({
  shouldForwardProp: (prop) => !['align'].includes(prop)
})<{ align?: Property.TextAlign }>`
  ${cellStyles}
`
